import type { IconPath } from '@nespresso-design-system/components';

export const icons: Record<string, IconPath> = {
  vertuo: '24/coffee/capsule-carafe-vl',
  original: '24/coffee/capsule-ol',
  pro: '24/professional/capsule-professional'
};
